import Widget from "./base.js";
import { getCookie, setCookie } from "tpm-utils";

export class MegaSaleModal extends Widget {
	componentWillMount() {
		const articleViews = getCookie("tpm_article_views");
		if (!articleViews || articleViews < 3) {
			this.state.dismissed = true;
			return;
		}

		const modalDismissed = getCookie("tpm_megasale_modal_dismissed");
		if (modalDismissed) this.state.dismissed = true;

		if (this.state.dismissed) return;

		this.dismiss = this.dismiss.bind(this);
	}

	componentDidMount() {
		this.centerVisually();
		window.addEventListener("resize", this.centerVisually, true);
	}

	centerVisually() {
		const m = document.querySelector(".MegaSaleModal__Inner");
		const h = m.offsetHeight / 2;
		m.setAttribute("style", "bottom: calc(50% - " + h + "px");
	}

	dismiss() {
		this.setState({ dismissed: true }, () => {
			setCookie("tpm_megasale_modal_dismissed", "1", 1);
		});
	}

	renderContent() {
		if (this.state.dismissed) return;

		return (
			<div className="MegaSaleModal__Inner">
				<div className="MegaSaleModal__Dismiss" onClick={this.dismiss}>
					<span style="pointer-events: none">
						<i class="fa-light fa-xmark"></i>
					</span>
				</div>

				<div className="MegaSaleModal__Container">
					<div className="MegaSaleModal__Neon --outer"></div>
					<div className="MegaSaleModal__Neon --inner"></div>
					<div className="MegaSaleModal__ItsComing">
						<img
							class="MegaSaleModal__ItsComingImg --desktop"
							src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/megasale/mega-sale-modal-image.png`}
							alt="One Year to Election Mega Sale"
						/>
					</div>
					<div className="MegaSaleModal__SubHeading">
						At TPM we do elections different.{" "}
					</div>
					<p>
						Join with an annual membership and you’ll have full access to TPM
						through the 2024 election
					</p>
					<a
						className="Button --red"
						href={`${document.location.origin}/memberships?utm_source=on_site&utm_medium=megasale&utm_campaign=memberships`}
					>
						30% Off Annual Memberships
					</a>
					{/* <img
						class="MegaSaleModal__Logo"
						src={`${document.location.origin}/wp-content/themes/tpm25/assets/images/megasale/mega-sale-1-year-white.png`}
						alt="One Year to Election Mega Sale"
					/> */}
				</div>
			</div>
		);
	}
}
